export default class ClusterService {

    async getClusters( cidades, estados ) {
        try {
            const response = await axios.post(route('web.clusters_por_nome_cidade.index'),{
                cidades: cidades,
                estados: estados
            });

            return response.data;

        } catch (error) {
            console.error('Error fetching clusters:', error);
            throw error;
        }
    }

}
